<template>
    <div class="h-screen pt-28 -mt-24 xl:pt-36 overflow-hidden">
        <div class="max-w-6xl mx-auto flex flex-col xl:flex-row">
            <div>
                <h1 class="text-blue-700">
                    404
                </h1>
                <div class="text-center text-[20px] xl:text-[22px] leading-10 tracking-wide">
                    您訪問的頁面不存在 <br>
                    <span class="text-blue-700">{{ second }}</span> 秒後將自動返回
                </div>
            </div>
            <div class="max-w-full overflow-hidden">
                <img
                    class="object-cover h-96 mx-auto xl:h-auto"
                    src="@/assets/images/404.svg"
                    alt=""
                >
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 不存在的頁面
 */
export default {
    name: 'E404View',
    /**
     * @param {Number} second 倒數秒數
     */
    data() {
        return {
            second: 3
        };
    },
    mounted() {
        this.countdown();
    },
    methods: {
        /**
         * 倒數計時，時間到頁面導到原始路徑
         * 
         * @public
         */
        countdown() {
            setTimeout(() => {
                if (this.second > 1) {
                    this.second --;
                    this.countdown();
                } else {
                    this.$router.push(`/${this.$route.params.type}`);
                }

            }, 1000);
        }
    }
};
</script>
<style scoped>
h1 {
    font-size: 150px;
    line-height: 261px;
    text-align: center;
    font-weight: bold;
}
@media screen and (max-width: 576px) {
    h1 {
        font-size: 120px;
        line-height: 200px;
    }
}
</style>